import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

function Navbar() {
  const navigate = useNavigate();
  const [userEmail, setUserEmail] = useState("");

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"));
    if (storedUser?.email) {
      setUserEmail(storedUser.email);
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    navigate("/signin");
  };

  return (
    <nav className="navbar navbar-dark bg-dark w-100 px-4 py-2" >
      <div className="d-flex justify-content-between align-items-center w-100">
        <div className="navbar-brand fw-bold fs-4">
          ALERP <span className="fs-6">(v1.0.0)</span>
        </div>
        <div className="d-flex align-items-center gap-3">
          <button
            className="btn btn-light btn-sm rounded-3 fw-bold"
            onClick={handleLogout}
          >
            Logout
          </button>
          <span className="text-white fw-semibold">{userEmail}</span>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
